// extracted by mini-css-extract-plugin
export default {"card":"News_card__OkHHp","wrapper":"News_wrapper__cJQI+","button":"News_button__Bzb-e"};